// extracted by mini-css-extract-plugin
module.exports = {"highTopMargin":"rX","lowTopMargin":"rY","rightColumnWrapper":"rZ","rightColumnTitle":"r0","title":"r1"};